import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { API_BASE_URL } from "../config";



const PurchaseSuccess = () => {
  const { transactionRef } = useParams();
  const navigate = useNavigate();

  const [sale, setSale] = useState(null);
  const [loading, setLoading] = useState(true);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    const fetchSale = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/payment/transaction/${transactionRef}`
        );
        if (!res.ok) throw new Error("Sale not found yet");

        const data = await res.json();
        setSale(data);
        setLoading(false);
      } catch (err) {
        if (attempts < 5) {
          setAttempts((a) => a + 1);
          setTimeout(fetchSale, 1500);
        } else {
          setLoading(false);
        }
      }
    };

    fetchSale();
  }, [transactionRef, attempts]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "120px" }}>
        <h2>Finalising your purchase…</h2>
        <p>Please wait while we confirm your payment.</p>
      </div>
    );
  }

  if (!sale) {
    return (
      <div style={{ textAlign: "center", marginTop: "120px" }}>
        <h2>Payment confirmed</h2>
        <p>
          Your payment was successful, but full sale details are still loading.
        </p>
        <p>Please refresh this page in a few seconds.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "750px",
        margin: "80px auto",
        padding: "30px",
        background: "#fff",
        borderRadius: "14px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <FaCheckCircle
        style={{ fontSize: "70px", color: "#2e7d32", marginBottom: "20px" }}
      />

      <h1 style={{ color: "#2e7d32", marginBottom: "10px" }}>
        Purchase Successful
      </h1>

      <p style={{ fontSize: "1.1rem", color: "#555" }}>
        Your payment has been successfully processed.
      </p>

      {/* TRANSACTION INFO */}
      <div
        style={{
          marginTop: "25px",
          padding: "16px",
          background: "#f1f8f4",
          borderRadius: "10px",
          fontWeight: "600",
          color: "#2e7d32",
        }}
      >
        Transaction Reference: {sale.transactionRef}
      </div>

      {/* LISTING SUMMARY */}
      <div
        style={{
          marginTop: "25px",
          textAlign: "left",
          maxWidth: "520px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h3 style={{ color: "#333" }}>{sale.title}</h3>
        <p style={{ color: "#666", margin: "4px 0" }}>
          {sale.suburb} ({sale.postcode})
        </p>
        <p style={{ margin: "6px 0" }}>
          <strong>Price Paid:</strong> ${sale.price}
        </p>
        <p style={{ margin: "6px 0" }}>
          <strong>Service Frequency:</strong> {sale.frequency}
        </p>
      </div>

      {/* WHAT HAPPENS NEXT */}
      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          background: "#f9fdfb",
          borderRadius: "12px",
          textAlign: "left",
          maxWidth: "520px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h3 style={{ color: "#2e7d32", marginBottom: "10px" }}>
          What happens next?
        </h3>
        <ul style={{ color: "#555", lineHeight: "1.7", paddingLeft: "20px" }}>
  <li>The seller has been notified that their listing has been purchased</li>
  <li>Client details and handover information will be shared via email</li>
  <li>Either party may initiate contact to arrange a smooth client handover</li>
  <li>You’ll receive a confirmation email once handover has been completed</li>
  <li>If there are any issues or delays, our support team can assist</li>
</ul>

      </div>

      {/* ACTION BUTTONS */}
      <div
        style={{
          marginTop: "40px",
          display: "flex",
          gap: "15px",
        }}
      >
        <button
          onClick={() => navigate("/dashboard")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#0288d1",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>

        <button
          onClick={() => navigate("/listings")}
          style={{
            flex: 1,
            padding: "14px",
            background: "#4caf50",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Browse More Listings
        </button>
      </div>
    </div>
  );
};

export default PurchaseSuccess;
